import { db } from '@otw/models/db'
import { deleteField, getDocs, query, updateDoc, where } from 'firebase/firestore'

/**
 * Clear `userId` on every CRM contact linked to a portal account.
 * Used when that account is deleted so contacts no longer point at a missing user.
 */
export const unlinkContactsFromUser = async (userId: string): Promise<number> => {
  const trimmedUserId = userId.trim()
  if (!trimmedUserId) return 0

  const snapshot = await getDocs(query(db.contacts, where('userId', '==', trimmedUserId)))
  if (snapshot.empty) return 0

  const now = new Date()
  await Promise.all(
    snapshot.docs.map(contactDoc =>
      updateDoc(contactDoc.ref, {
        userId: deleteField(),
        updatedAt: now,
      }),
    ),
  )

  return snapshot.size
}
